import { render, staticRenderFns } from "./singleLogin.vue?vue&type=template&id=95184d10&scoped=true"
import script from "./singleLogin.vue?vue&type=script&lang=js"
export * from "./singleLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95184d10",
  null
  
)

export default component.exports